import { render } from "./AnnouncementDetail.vue?vue&type=template&id=2f6aac71&scoped=true&ts=true"
import script from "./AnnouncementDetail.ts?vue&type=script&lang=ts"
export * from "./AnnouncementDetail.ts?vue&type=script&lang=ts"

import "./AnnouncementDetail.scss?vue&type=style&index=0&id=2f6aac71&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6aac71"]])

export default __exports__